import React from 'react'
import { Row, Col, Table } from 'react-bootstrap'

type ClaimDetailsProps = {
  claimInfo: {
    claimID: string
    claimBillingOrder: string
    claimDOSDates: string
    claimCreatedBy: string
    claimCreatedOn: string
    lastStatusUpdateDate: string
  }
  claimStatus: {
    claimSentDateType: string
    claimSentStatus: string
    claimCloseDate: string
    claimClosedBy: string
    claimStatus: string
    dxcAttachmentID: string
  }
  claimAmount: {
    totalSubmittedFees: string
    totalFee: string
    totalEstimatedInsurance: string
    totalInsurancePaid: string
    variance: string
    other: string
  }
  insurancePayment: {
    checkNumber: string
    bankNumber: string
    eobNumber: string
  }
}

const ClaimDetails = ({
  claimInfo,
  claimStatus,
  claimAmount,
  insurancePayment,
}: ClaimDetailsProps): React.ReactElement => {
  return (
    <Row className="mb-2">
      <Col md={3}>
        <div className="bg-custom3 text-dark ps-3 p-1 rounded-top">
          <span className="fw-bold fs-5">Claim Information</span>
        </div>
        <Table bordered striped>
          <tbody>
            <tr>
              <th>Claim ID</th>
              <td>{claimInfo.claimID}</td>
            </tr>
            <tr>
              <th>Claim Billing Order</th>
              <td>{claimInfo.claimBillingOrder}</td>
            </tr>
            <tr>
              <th>Claim DOS Dates</th>
              <td>{claimInfo.claimDOSDates}</td>
            </tr>
            <tr>
              <th>Claim Created By</th>
              <td>{claimInfo.claimCreatedBy}</td>
            </tr>
            <tr>
              <th>Claim Created On</th>
              <td>{claimInfo.claimCreatedOn}</td>
            </tr>
            <tr>
              <th>Last Status Update Date</th>
              <td>{claimInfo.lastStatusUpdateDate}</td>
            </tr>
          </tbody>
        </Table>
      </Col>
      <Col md={3}>
        <div className="bg-custom3 text-dark ps-3 p-1 rounded-top">
          <span className="fw-bold fs-5">Claim Status</span>
        </div>
        <Table bordered striped>
          <tbody>
            <tr>
              <th>Claim Sent Date / Claim Type</th>
              <td>{claimStatus.claimSentDateType}</td>
            </tr>
            <tr>
              <th>Claim Sent Status</th>
              <td>{claimStatus.claimSentStatus}</td>
            </tr>
            <tr>
              <th>Claim Close Date</th>
              <td>{claimStatus.claimCloseDate}</td>
            </tr>
            <tr>
              <th>Claim Closed By</th>
              <td>{claimStatus.claimClosedBy}</td>
            </tr>
            <tr>
              <th>Claim Status</th>
              <td>{claimStatus.claimStatus}</td>
            </tr>
            <tr>
              <th>DXC Attachment ID</th>
              <td>{claimStatus.dxcAttachmentID}</td>
            </tr>
          </tbody>
        </Table>
      </Col>
      <Col md={3}>
        <div className="bg-custom3 text-dark ps-3 p-1 rounded-top">
          <span className="fw-bold fs-5">Claim Amount</span>
        </div>
        <Table bordered striped>
          <tbody>
            <tr>
              <th>a. Total Submitted Fees</th>
              <td>{claimAmount.totalSubmittedFees}</td>
            </tr>
            <tr>
              <th>b. Total Fee</th>
              <td>{claimAmount.totalFee}</td>
            </tr>
            <tr>
              <th>c. Total Est. Ins</th>
              <td>{claimAmount.totalEstimatedInsurance}</td>
            </tr>
            <tr>
              <th>d. Total Ins Paid</th>
              <td>{claimAmount.totalInsurancePaid}</td>
            </tr>
            <tr>
              <th>Variance (c-d)</th>
              <td>{claimAmount.variance}</td>
            </tr>
            <tr>
              <th>Other</th>
              <td>{claimAmount.other}</td>
            </tr>
          </tbody>
        </Table>
      </Col>
      <Col md={3}>
        <div className="bg-custom3 text-dark ps-3 p-1 rounded-top">
          <span className="fw-bold fs-5">Insurance Payment</span>
        </div>
        <Table bordered striped>
          <tbody>
            <tr>
              <th>Check #</th>
              <td>{insurancePayment.checkNumber}</td>
            </tr>
            <tr>
              <th>Bank #</th>
              <td>{insurancePayment.bankNumber}</td>
            </tr>
            <tr>
              <th>EOB #</th>
              <td>{insurancePayment.eobNumber}</td>
            </tr>
            <tr>
              <th>-</th>
              <td>-</td>
            </tr>
            <tr>
              <th>-</th>
              <td>-</td>
            </tr>
            <tr>
              <th>-</th>
              <td>-</td>
            </tr>
          </tbody>
        </Table>
      </Col>
    </Row>
  )
}

export default ClaimDetails
